import { scrollToElem } from "./support";

export const forms = () => {
  // Form Validation
  let recaptcha = false;

  document.querySelectorAll(".js-validate").forEach((form) => {
    if (form.querySelector(".g-recaptcha")) {
      recaptcha = document
        .querySelector("meta[name='google_recaptcha_site_key']")
        .getAttribute("content");
    }

    new Validate(form, {
      recaptchaSiteKey: recaptcha,
      fieldFeedbackSelector: ".js-field-feedback span",
      ajax: true,
      ajaxSuccessCallback: (form) => {},
      ajaxErrorCallback: (form, errors) => {
        console.log(errors);
        Object.keys(errors).forEach((key) => {
          const input = form.querySelector(`[name="${key}"]`);
          if (input) {
            const fieldFeedback = input.closest(".js-field-feedback");
            if (fieldFeedback) {
              const span = fieldFeedback.querySelector("span");
              if (span) {
                errors[key].forEach((message) => {
                  span.innerHTML += message + " ";
                });
              }
            }
          }
        });
      },
    });

    // Focus invalid field behaviour
    form.addEventListener("submit", function () {
      let invalidField = form.querySelector(".js-field.is-invalid");
      if (invalidField) {
        scrollToElem(invalidField);
      }
    });
  });
};
